
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeSmallCraftOutlined as ObiVesselTypeSmallCraftOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-small-craft-outlined.js';
 
 
 

 
 export const ObiVesselTypeSmallCraftOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-small-craft-outlined',
   elementClass: ObiVesselTypeSmallCraftOutlinedElement,
   events: {
     
   }
  });
 
 